import React from 'react';
import bizCalc1 from '../../assets/home/ecosystem/biz-calc1.png';
import bizCalc2 from '../../assets/home/ecosystem/biz-calc2.png';
import challenge1 from '../../assets/home/ecosystem/challenge-1.png';
import challenge2 from '../../assets/home/ecosystem/challenge-2.png';
import climateEquity from '../../assets/home/ecosystem/climate-equity.png';
import davisScenarios from '../../assets/home/ecosystem/davis-scenarios.png';
import householdCalc1 from '../../assets/home/ecosystem/household-calc1.png';
import householdCalc2 from '../../assets/home/ecosystem/household-calc2.png';
import { MEMBERSHIP_AGREEMENT_PDF_URL } from '../../constants/membershipPricing';
import { HomeSectionShell } from './HomeSectionShell';
import { ECOSYSTEM_APPS, ECOSYSTEM_SECTION } from './homePageConstants';

type EcosystemScreenshot = {
  primary: string;
  hover?: string;
  primaryAlt: string;
  hoverAlt?: string;
};

const ECOSYSTEM_SCREENSHOTS: Record<string, EcosystemScreenshot> = {
  climateplans: {
    primary: davisScenarios,
    hover: climateEquity,
    primaryAlt: 'ClimatePlans scenario planning view for Davis',
    hoverAlt: 'ClimatePlans climate equity indicators view',
  },
  calculator: {
    primary: householdCalc1,
    hover: householdCalc2,
    primaryAlt: 'CoolClimate Household Calculator overview',
    hoverAlt: 'CoolClimate Household Calculator results view',
  },
  business: {
    primary: bizCalc1,
    hover: bizCalc2,
    primaryAlt: 'CoolClimate Calculator for Businesses overview',
    hoverAlt: 'CoolClimate Calculator for Businesses results view',
  },
  challenge: {
    primary: challenge1,
    hover: challenge2,
    primaryAlt: 'Cool Campus Challenge overview',
    hoverAlt: 'Cool Campus Challenge leaderboard and engagement view',
  },
};

export const EcosystemSection: React.FC = () => (
  <HomeSectionShell
    id="coolclimate-ecosystem"
    title={ECOSYSTEM_SECTION.title}
    subtitle={
      <>
        {ECOSYSTEM_SECTION.subtitleLead} See the{' '}
        <a href={MEMBERSHIP_AGREEMENT_PDF_URL} target="_blank" rel="noopener noreferrer">
          CoolClimate membership agreement
        </a>{' '}
        for access to these tools.
      </>
    }
    variant="muted"
  >
    <div className="home-card-grid home-card-grid--three home-ecosystem-grid">
      {ECOSYSTEM_APPS.map((app) => {
        const screenshots = ECOSYSTEM_SCREENSHOTS[app.id];
        const hasHoverSwap = Boolean(screenshots?.hover);

        return (
          <article key={app.id} className="home-ecosystem-card">
            {screenshots ? (
              <div
                className={`home-ecosystem-card__screenshot${
                  hasHoverSwap ? ' home-ecosystem-card__screenshot--swap' : ' home-ecosystem-card__screenshot--static'
                }`}
              >
                <img
                  src={screenshots.primary}
                  alt={screenshots.primaryAlt}
                  className="home-ecosystem-card__screenshot-img home-ecosystem-card__screenshot-img--primary"
                  loading="lazy"
                  decoding="async"
                />
                {screenshots.hover ? (
                  <img
                    src={screenshots.hover}
                    alt={screenshots.hoverAlt || screenshots.primaryAlt}
                    className="home-ecosystem-card__screenshot-img home-ecosystem-card__screenshot-img--hover"
                    loading="lazy"
                    decoding="async"
                  />
                ) : null}
                {hasHoverSwap ? (
                  <span className="home-ecosystem-card__screenshot-hint">Hover to preview</span>
                ) : null}
              </div>
            ) : null}
            <h3 className="home-ecosystem-card__title">{app.name}</h3>
            <p className="home-ecosystem-card__desc">{app.description}</p>
            {app.external ? (
              <a
                href={app.href}
                className="home-ecosystem-card__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit →
              </a>
            ) : (
              <span className="home-ecosystem-card__here">You are here</span>
            )}
          </article>
        );
      })}
    </div>
  </HomeSectionShell>
);
